// TODO: Make normal mixin instead of global
import accesslevels from '@utils/accesslevels'
export default {
  computed: {
    $_allStates() {
      return this.$store.getters['masterData/allStates']
    },

    $_suffixes() {
      return this.$store.getters['masterData/suffixes']
    },

    $_CCRLoanTypes() {
      return this.$store.getters['masterData/CCRLoanTypes']
    },

    $_maritalStatuses() {
      return this.$store.getters['masterData/maritalStatuses']
    },

    $_salutationList() {
      return this.$store.getters['masterData/salutationList']
    },
    $_supplementStatusList() {
      return this.$store.getters['masterData/supplementStatusList']
    },
    $_rescoreStatusList() {
      return this.$store.getters['masterData/rescoreStatusList']
    },
    $_tradelineStatusList() {
      return this.$store.getters['masterData/rescoreTradelineStatusList']
    },
    $_requestTypesList() {
      return this.$store.getters['masterData/requestTypesList']
    },
    $_transactionHistoryList() {
      return this.$store.getters['masterData/transactionHistoryList']
    },
    $_refreshPeriodList() {
      return this.$store.getters['masterData/refreshPeriodList']
    },
    // $_accountTypeList() {
    //   return this.$store.getters['masterData/accountTypeList']
    // },

    $_cities() {
      return this.$store.getters['masterData/cities']
    },

    $_formattedCities() {
      return this.$store.getters['masterData/formattedCities']
    },

    $_counties() {
      return this.$store.getters['masterData/counties']
    },

    $_formattedCounties() {
      return this.$store.getters['masterData/formattedCounties']
    },

    $_selectedTimeZone() {
      return this.$store.getters['masterData/selectedTimeZone']
    },
    $_canAccessCpProcessor() {
      let Cpaccess = accesslevels(6)
        ? accesslevels(6) && !!+process.env.VUE_APP_SHOW_PREPROD_MODULES
        : true
      return Cpaccess
    },
    $_canAccessCustomerAdmin() {
      let Cpaccess = accesslevels(7)
        ? accesslevels(7) && !!+process.env.VUE_APP_SHOW_PREPROD_MODULES
        : true
      return Cpaccess
    },
    $_canAccessCpAdmin() {
      let Cpaccess = accesslevels(0)
        ? accesslevels(0) && !!+process.env.VUE_APP_SHOW_PREPROD_MODULES
        : true
      return Cpaccess
    },
    $_portfolioList() {
      return this.$store.getters['masterData/portfolioList']
    },
    $_currentUser() {
      let header = this.$store.state.auth.currentUser.userInfo
      return header.firstName + header.lastName
    },
    $_userFullName() {
      let header = this.$store.state.auth.currentUser.userInfo
      return header.firstName + ' ' + header.lastName
    },
    $_isTrnEnvironment() {
      return !!+process.env.VUE_APP_SHOW_PREPROD_MODULES
    },
  },
}
